<div class="flex flex-col sm:flex-row w-full justify-between items-start sm:items-center mb-8">
  <h1 class="font-bold mb-0 overflow-hidden whitespace-nowrap text-ellipsis w-full">
    {{ { key: bucket() } | i18n }}
  </h1>
</div>

@if (documents.isLoading()) {
  <div class="flex justify-center items-center h-64">
    <app-loading [noWhitespace]="true"></app-loading>
  </div>
} @else if (documents.error()) {
  <div class="flex justify-center items-center h-64">
    <div class="text-red-500">{{ { key: 'errorLoading' } | i18n }}</div>
  </div>
} @else {
  <div class="flex flex-col gap-4">
    @for (doc of documents.value(); track doc._id) {
      <a
        class="flex flex-col hover:bg-opacity-10 hover:bg-primary-600 rounded-md p-4 border border-primary-600"
        [routerLink]="['/', 'account', 'document', bucket(), doc._id]"
      >
        <div class="flex items-center">
          <div class="flex min-w-0 flex-1 items-center">
            <div class="min-w-0 flex-1 md:grid md:grid-cols-2 gap-4">
              <div>
                <p class="truncate font-bold">
                  {{ doc.combinedNumber }}
                </p>
                @if (bucket() === 'invoice') {
                  <p class="mt-2 mb-0 flex items-center text-sm text-gray-500">
                    <span class="truncate">{{ doc.totalAmountInclVat | bbitFormatPrice }}</span>
                  </p>
                }
              </div>
              <div class="hidden md:block">
                <div>
                  <p class="text-sm text-gray-900">
                    <time>{{ { date: doc.date, format: 'dd.LL.yyyy' } | luxon }}</time>
                  </p>
                  @if (bucket() === 'invoice') {
                    <p class="mt-2 mb-0 flex items-center text-sm text-gray-500">
                      @if ((doc.openAmount?.amount || 0) > 0) {
                        <ng-icon
                          name="heroExclamationTriangleSolid"
                          class="mr-1.5 h-5 w-5 flex-shrink-0 text-red-700"
                          size="24px"
                        ></ng-icon>
                        {{ doc.openAmount | bbitFormatPrice }}
                        {{ { key: 'open' } | i18n }}
                      }
                      @if ((doc.openAmount?.amount || 0) <= 0) {
                        <ng-icon name="heroCheckCircleSolid" class="mr-1.5 h-5 w-5 flex-shrink-0 text-green-700" size="24px"></ng-icon>
                        {{ { key: 'paid' } | i18n }}
                      }
                    </p>
                  }
                </div>
              </div>
            </div>
          </div>
          <div>
            <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fill-rule="evenodd"
                d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </a>
    } @empty {
      <div class="text-gray-500">{{ { key: 'noEntries' } | i18n }}</div>
    }
  </div>
}
